window._ = require('lodash');

try {
    window.$ = window.jQuery = require('jquery');
    window.bootstrap = require('bootstrap');
    // window.Cropper = require('cropperjs');
    window.slick = require('slick-carousel');
    // window.AOS = require('aos');
    // AOS.init();
    window.EasyMDE = require('easymde');

    $('textarea.markdown').each(function() {
        let easyMDE = new EasyMDE({
            toolbar: ["bold", "italic", "|", "link", "|", "preview"],
            spellChecker: false,
            element: this,
        });
    })


    window.select2 = require('select2');
    $('select.select2').each(function() {
        $(this).select2();
    })
} catch (e) {}

$('.slick-presentation').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    // centerMode: true,
    // centerPadding: '18rem',
    // dots: true,
});

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
